import * as yup from 'yup';
import { validPrefix } from '../utils/phoneNumber';
import { validEmail, validPhoneCharacters } from '../utils/regex';

export const approvedOptions = [
  { value: `Yes- I'm sorted`, label: `Yes- I'm sorted` },
  { value: `No- haven't organised it yet`, label: `No- haven't organised it yet` },
  { value: `No- can you recommend a mortgage broker`, label: `No- can you recommend a mortgage broker` },
  { value: `No- don't need a mortgage for the purchase`, label: `No- don't need a mortgage for the purchase` },
  { value: `I'd rather not say`, label: `I'd rather not say` },
];

export const toSellOptions = [
  { value: `Yes- it's already on the market`, label: `Yes- it's already on the market` },
  { value: `Yes- not on the market`, label: `Yes- not on the market` },
  { value: `No`, label: `No` },
];

export const propertyTypeOptions = [
  { value: `Detached`, label: `Detached` },
  { value: `Semi-detached`, label: `Semi-detached` },
  { value: `Townhouse`, label: `Townhouse` },
  { value: `Apartment`, label: `Apartment` },
  { value: `Other`, label: `Other` },
];

export const validationSchema = (registerInterestModal?: boolean) => {
  const schema: any = {
    email: yup
      .string()
      .trim()
      .matches(validEmail, 'Please enter a valid email address')
      .required('Please enter your email address'),
    prefix: yup.string().trim().test(validPrefix).required('Please include a country code'),
    tel: yup
      .string()
      .trim()
      .matches(validPhoneCharacters, 'Please enter a valid phone number')
      .required('Please enter your phone number'),
    name: yup.string().trim().required('Please enter your name'),
    body: yup.string().trim().required('Please enter a message'),
    accountNumber: yup.string().required('Please select a contact'),
    customData: yup.object(),
  };

  if (registerInterestModal) {
    schema.propertyType = yup.string().required('Please select a property type');
    schema.areYouApproved = yup.string().required('Please select if you are approved for a mortgage');
    schema.propertyToSell = yup.string().required('Please select if you have a property to sell');
  }

  return yup.object().shape(schema);
};
